export default __webpack_public_path__ + "static/media/promo-usdc.64a22109.svg";